import camelCase from 'lodash/camelCase';
import type { Reducer } from 'redux';

const reducer: Reducer<FetchingFlags> = (state = {}, action) => {
  const matches = /(.*)_(REQUEST|SUCCESS|FAIL)/.exec(action.type);

  if (!matches) {
    return state;
  }

  const [, requestName, requestState] = matches;
  return {
    ...state,
    [camelCase(`${requestName}_COMPLETE`)]: requestState !== 'REQUEST',
    [camelCase(`${requestName}_FETCHING`)]: requestState === 'REQUEST',
  };
};

export default reducer;

export type FetchingFlags = Record<string, boolean | undefined>;
